import _ from "lodash";

const buildQueryStringParameters = (objQueryParams: { [key: string]: any }) => {
	const filteredQueryParams = _.omitBy(objQueryParams, _.isNil);
	return (
		"?" +
		Object.keys(filteredQueryParams)
			.map((key) => `${key}=${encodeURIComponent(filteredQueryParams[key])}`)
			.join("&")
	);
};

export { buildQueryStringParameters };
